/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react'

import fetch, { IBaseResponse } from 'lib/decorated-fetch'
import getUrl from 'lib/url'

import styles from './styles.module.scss'
import { metrics } from 'lib/slardar-utils'

export interface IInnerLink {
  title?: string
  url?: string
}

export interface IInnerLinkProps {
  linkList: IInnerLink[]
}

const logger = (uri: string, req?: any) => {
  if (req) {
    req.metrics.emitCounter('seo.inner_link.fail', 1, undefined, {
      uri,
    })
  } else {
    metrics.counter(`seo.inner_link.fail`, {
      uri,
    })
  }
  return []
}

export const getInnerLinkList = async (uri: string, req?: any) => {
  if (!req?.isSpider) return []
  try {
    const json: IBaseResponse<IInnerLink[]> = await fetch(
      getUrl(
        `/motor/pc/common/seo/inner_link?uri=${uri}`,
        'motor.pc_common.api'
      ),
      { req }
    )
    if (0 !== json?.status) {
      return logger(uri, req)
    }
    return json?.data
  } catch {
    return logger(uri, req)
  }
}

export default function InnerLink(props: IInnerLinkProps) {
  const { linkList } = props
  if (!linkList.length) return null
  return (
    <div className="tw-border-t-1 tw-pt-12 tw-m-16 tw-text-color-gray-600">
      <span>热门：</span>
      {linkList.map((link, index) => (
        <a
          href={link.url}
          target="_blank"
          key={index}
          className={styles['link-item']}
        >
          {link.title}
        </a>
      ))}
    </div>
  )
}
